import React, { PropsWithChildren } from "react";
//#region types
import { AccordionPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import SimpleExpansionPanel from "./simpleExpansionPanel";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const AccordionPanel: React.FC<PropsWithChildren<AccordionPanelProps>> = (props) => {
  return (
    <Grid item xs={12} className={cssExports.accordionPanel}>
      <SimpleExpansionPanel
        title={props.title}
        titleExtraText={props.titleExtraText}
        defaultExpanded={props.defaultExpanded}
        borderless
        className={props.className}
      >
        {props.children}
      </SimpleExpansionPanel>
    </Grid>
  );
};

export default AccordionPanel;
